import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuth: false,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setAuth: (state, action) => {
      state.isAuth = action.payload;
    },
    setUser: (state, action) => ({
      isAuth: true,
      ...action.payload,
    }),
    logout: () => initialState,
  },
});

export const { setAuth, setUser, logout } = userSlice.actions;

export default userSlice.reducer;
